import { Flex, Badge, Em, Text } from "@radix-ui/themes";
import { OptionalFieldGroup } from "./FieldGroup";
import { EmailListInput } from "./EmailListInput";

interface SendQuestionsByContextAtBeginningProps {
  enabled?: boolean;
  emails?: string[];
  onChange: (enabled: boolean) => void;
  onEmailsChange: (emails: string[]) => void;
}

export function SendQuestionsByContextAtBeginning({
  enabled = false,
  emails = [],
  onChange,
  onEmailsChange,
}: SendQuestionsByContextAtBeginningProps) {
  return (
    <OptionalFieldGroup
      label={
        <Flex align="center" gap="2">
          <Text size="2">Show Context-Based Suggestions on Chat Open</Text>
          <Badge color="plum" variant="soft" highContrast>
            <Em>Beta</Em>
          </Badge>
        </Flex>
      }
      description={
        "Show suggested questions based on context when the chat opens."
      }
      enabled={enabled ?? false}
      toggleEnabled={onChange}
    >
      {enabled && (
        <Flex mt="2" direction="column" gap="2">
          <Text size="2" color="gray">
            Enable context-based suggestions for specific email addresses
          </Text>
          <EmailListInput emails={emails} onChange={onEmailsChange} />
        </Flex>
      )}
    </OptionalFieldGroup>
  );
}
